module.exports = __webpack_public_path__ + "img/00019.c3e987fe.webp";